import * as React from 'react';
import IAsset from '../models/asset';
const classnames = require('classnames');

interface State {
  selected: boolean;
}

interface Props {
  asset: IAsset;
  className ?: string;
  playable ?: boolean;
  onClick ?: any;
  iconClick ?: any;
}

export default class AssetCard extends React.Component<Props, State> {
  public static defaultProps: Partial<Props> = {
    playable: true
  };

  componentWillMount() {
    this.setState({
        selected: false
    });
  }

  renderCardContent(asset: IAsset) {
      return asset == null
        ? <div className="card-content card-content-blank" />
        : (
            <div className={classnames('card-content', asset.modified ? 'modified' : 'unmodified')} >
                <i className="card-action-icon no-caption fa fa-trash" onClick={this.props.iconClick} title="Delete Alias"/>
                {/*<i className="card-action-icon no-caption fa fa-trash" style={{ color: 'pink' }} onClick={this.props.iconClick} title="Delete Alias"/>*/}
                <h1 title={this.props.asset.url}>{this.props.asset.name}</h1>
          </div>
          );
  }

  render() {
    return (
        <div className={`card asset-card ${this.props.className}`} onClick={this.props.onClick}>
            {this.renderCardContent(this.props.asset)}
            {this.props.children}
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/panels/asset-card.tsx